module.exports = __webpack_public_path__ + "img/sfgs400.d2ed9db0.jpg";